<template>
    <div class="c-search" :class="{ 'c-search--product-page' : isProductPage, 'c-search--error' : isError }">
        <input class="c-search__input ds-text-label-md ds-text--regular"
			   :class="{ 'c-search__input--product-page': isProductPage }"
			   type="text"
			   v-model="term"
			   @keydown.enter="search"
			   @keydown.esc="reset"
			   @keyup="onKeyUp"
			   ref="input"
			   :placeholder="placeholder"
               role="search" />
		<DsIconButton
				@click.prevent="search"
				class=" c-search__button"
				aria-label="SEARCH"
				icon-name="search"
				data-testid="search-button"
				tabindex="-1"
				variant="ghost-neutral" />
		<DsIconButton
				@click.prevent="reset"
				class="c-search__button--close"
				:class="{'visible': term !== ''}"
				aria-label="RESET"
				icon-name="close"
				data-testid="reset-keyword"
				tabindex="-1"
				variant="ghost-neutral"
				size="sm" />
        <slot></slot>
    </div>
</template>

<script>
import { throttle } from 'lodash';
import { productSearchEvents } from 'shared/settings/constants';
import { mapGetters, mapMutations } from 'vuex';
import { DsIconButton  } from '@coloplast/design-system';

const shortCodeRegex = /^[A-Za-z0-9]{4,6}$/;

export default {
	name: 'search-field',
    props: [
        'vm',
        'placeholder',
        'isProductPage',
        'flag',
		'isError',
		'enableManufacturerTabs',
    ],
    data() {
        return {
            previousTerm: '',
        };
	},
	components: {
		DsIconButton
	},
	emits: [
			productSearchEvents.RESET,
			productSearchEvents.SEARCH,
			productSearchEvents.SHORT_CODE_SEARCH,
			productSearchEvents.AUTO_SUGGEST_SEARCH,
			productSearchEvents.UP,
			productSearchEvents.DOWN
	],
    computed: {
        ...mapGetters({
            getSearchTerm: 'getSearchTerm'
        }),
        term: {
            get() {
                return this.getSearchTerm;
            },
            set(val) {
				this.setSearchTerm(val);
            }
        }
    },
	methods: {
        ...mapMutations({
            setSearchTerm: 'setSearchTerm'
        }),
		search() {
			if (this.isProductPage) {
				this.$emit(productSearchEvents.SEARCH, { query: this.term  });
				return;
			}

			if (shortCodeRegex.test(this.term)) {
				this.$emit(productSearchEvents.SHORT_CODE_SEARCH, { code: this.term });
			}
			else {
				this.$emit(productSearchEvents.SEARCH, { term: this.term });
			}
        },
		reset() {
			this.$emit(productSearchEvents.RESET);
			this.term = '';
			this.search();
        },
        onKeyUp: throttle(function autoSuggestSearch() {
            if (this.term !== this.previousTerm) {
                this.$emit(productSearchEvents.AUTO_SUGGEST_SEARCH, { term: this.term });
                this.previousTerm = this.term;
            }
        }, 500),
    },
}
</script>
